/**
 * es-ES translations for the public onboarding funnel (formal register).
 *
 * Anonymous, pre-identity surfaces: self-service sign-up, the payment return
 * page and the invitation landing. No technology names in any string.
 */

const onboarding = {
  signup: {
    title: 'Cree su cuenta',
    subtitle: 'Empiece a atender a sus huéspedes en unos minutos.',
    steps: {
      plan: 'Plan',
      details: 'Sus datos',
      request: 'Su solicitud',
    },
    choose_plan: 'Elija un plan',
    choose_plan_help: 'Podrá cambiar de plan más adelante desde su panel.',
    per_month: 'al mes',
    per_year: 'al año',
    per_days: 'cada %{count} días',
    plan_features: {
      static_qr: 'Códigos QR estáticos: %{count}',
      dynamic_qr: 'Códigos QR dinámicos: %{count}',
      staff: 'Miembros del personal: %{count}',
      unlimited: 'sin límite',
    },
    selected: 'Seleccionado',
    select: 'Seleccionar',
    details_title: 'Sus datos',
    details_help:
      'No es necesario crear una contraseña ahora: le enviaremos un correo electrónico para establecerla y acceder de forma segura.',
    request_help:
      'Déjenos sus datos y nos pondremos en contacto con usted para completar el alta. No se crea ninguna cuenta ni se realiza ningún cobro en este paso.',
    sent_title: 'Hemos recibido su solicitud',
    sent_body:
      'Gracias por su interés. Nos pondremos en contacto con usted para completar el alta y resolver cualquier duda.',
    sent_help: 'No es necesario que haga nada más. No se ha realizado ningún cobro.',
    fields: {
      full_name: 'Nombre y apellidos',
      email: 'Correo electrónico',
      company_name: 'Nombre de su empresa',
      contact_no: 'Teléfono (opcional)',
      notes: 'Notas (opcional)',
      notes_help: 'Cuéntenos cualquier cosa que debamos tener en cuenta al preparar su alta.',
    },
    continue: 'Continuar',
    back: 'Volver',
    submit: 'Continuar al pago',
    submit_request: 'Enviar solicitud',
    submitting: 'Procesando…',
    loading_plans: 'Cargando planes…',
    no_plans: 'No hay planes disponibles en este momento. Inténtelo de nuevo más tarde.',
    error_generic: 'No se ha podido completar el registro. Inténtelo de nuevo.',
    error_plans: 'No se han podido cargar los planes. Inténtelo de nuevo más tarde.',
    error_request_generic: 'No se ha podido enviar su solicitud. Inténtelo de nuevo.',
    error_too_many:
      'Ha enviado varias solicitudes seguidas. Espere unos minutos antes de volver a intentarlo; si ya nos ha escrito, no hace falta que repita el envío.',
    retry: 'Reintentar',
    have_account: '¿Ya tiene una cuenta?',
    sign_in: 'Acceda aquí',
  },
  payment: {
    confirming_title: 'Estamos confirmando su pago',
    confirming_body:
      'Espere unos instantes, no cierre esta página. Estamos preparando su cuenta.',
    success_title: 'Pago confirmado',
    success_body:
      'Su cuenta está lista. Le hemos enviado un correo electrónico para que establezca su contraseña y pueda acceder.',
    timeout_title: 'Su pago se está procesando',
    timeout_body:
      'Estamos finalizando la preparación de su cuenta. Recibirá un correo electrónico para establecer su contraseña en cuanto esté lista.',
    missing_session_title: 'No se ha encontrado la información del pago',
    missing_session_body:
      'Vuelva a iniciar el registro. Si el problema persiste, póngase en contacto con nosotros.',
    go_to_sign_in: 'Ir al acceso',
    back_to_signup: 'Volver al registro',
  },
  invite: {
    title: 'Le han invitado a unirse',
    body:
      'Le hemos enviado un correo electrónico para que establezca su contraseña. Una vez establecida, acceda con el botón inferior.',
    body_existing:
      'Su acceso ya está preparado. Acceda con el botón inferior con sus credenciales habituales.',
    go_to_sign_in: 'Ir al acceso',
  },
};

export default onboarding;
